import React, { useEffect, useState } from 'react'
import { FaCheck, FaEdit, FaTimes, FaTrashAlt } from 'react-icons/fa'
// Utils
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { setToken } from '../../../features/auth/authSlice'
import {
  getDestinationsArea,
  getOrderDetail,
  setDestinationList,
  updateOrderDestination,
  updateDistributionQuantity,
  deleteDistributionDestination,
  confirmDistributionDestination,
} from '../../../features/order/orderSlice'
import SpinnerComp from '../../util/SpinnerComp'
import { prefecture_list } from '../../../static_data/data'

const DistibutionArea = ({ customStyles, token, dataDetail }) => {
  const destinationsList = dataDetail?.destinations
  // console.log(destinationsList)
  // const destinationsListQty = dataDetail.destinations.quantity
  const [total, setTotal] = useState(0)
  //
  // Modal
  const [targetData, setTargetData] = useState(null)
  //
  const [currentIndex, setCurrentIndex] = useState(null)
  const [quantity, setQuantity] = useState(0)
  const [zip, setZip] = useState('')
  const [address, setAddress] = useState('')
  const [name, setName] = useState('')
  const [prefCodeDest, setPrefCodeDest] = useState('')
  const [tel, setTel] = useState('')
  const [shippingCompany, setShippingCompany] = useState(
    targetData?.shipping_company || ''
  )
  //

  useEffect(() => {
    setTotal(
      destinationsList?.reduce((tot, ex) => {
        return tot + ex.quantity || 0
      }, 0)
    )
  }, [destinationsList])

  const [modalDistOpen, setModalDistIsOpen] = useState(false)
  const toggleDistSteps = () => {
    setModalDistIsOpen((prev) => !prev)
  }

  //   redux
  const dispatch = useDispatch()
  const addDestinationAreaHandler = (e) => {
    e.preventDefault()
    toggleDistSteps()
    dispatch(getDestinationsArea(token))
  }

  const { destinations, destinations_list, order_destination_loading } =
    useSelector((state) => state.order)
  const destinationsValue = destinations?.value

  const [filteredDestinations, setFilteredDestinations] = useState(null)

  useEffect(() => {
    if (destinationsValue && destinationsList) {
      const filtered = destinationsValue?.filter((item) =>
        destinationsList?.every((otherItem) => otherItem.id !== item.id)
      )

      setFilteredDestinations(filtered)
    } else {
      setFilteredDestinations(destinationsValue)
    }
  }, [destinationsValue, destinationsList])
  //   Set destination for checked
  useEffect(() => {
    if (destinationsValue && destinations.error_message !== 'token_expired')
      dispatch(setDestinationList(destinationsValue))
    // eslint-disable-next-line
  }, [destinationsValue])

  // initial state (local)
  const [selectedDestination, setSelectedDestination] = useState([])
  useEffect(() => {
    if (destinations_list && destinations.result === 'success') {
      setSelectedDestination(destinations_list[0])
    }
    // eslint-disable-next-line
  }, [destinations_list])

  //   Updating selected Destination
  const [destinationSelected, setDestinationSelected] = useState([])
  useEffect(() => {
    if (selectedDestination?.length > 0) {
      const checkedDestination = selectedDestination.filter(
        (dest) => dest.checked
      )
      setDestinationSelected(checkedDestination.map((dest) => dest))
    }
    //   eslint-disable-next-line
  }, [dispatch, selectedDestination])

  // Check Handler
  const checkHandler = (value) => {
    setSelectedDestination((prev) =>
      prev.map((dest) => {
        const temp = { ...dest }
        if (dest.id === value) {
          temp.checked = !temp.checked
        }
        return temp
      })
    )
  }

  const submitAddDestinationAreaHandler = (e) => {
    e.preventDefault()
    const data = {
      order_key: dataDetail.order_key,
    }
    const dataUpdateOrderDestination = {
      order_key: dataDetail.order_key,
      destinations: destinationSelected,
    }
    dispatch(updateOrderDestination({ dataUpdateOrderDestination, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('配送先情報が更新されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleDistSteps()
  }
  const submitFreeText = (e) => {
    e.preventDefault()
    const data = {
      order_key: dataDetail.order_key,
    }
    if (
      name === '' ||
      tel === '' ||
      address === '' ||
      zip === '' ||
      prefCodeDest === ''
    ) {
      return
    }
    const quanParse = Number(quantity)
    const dataUpdateOrderDestination = {
      order_key: dataDetail.order_key,
      destinations: [
        {
          id: -1,
          checked: true,
          name,
          tel,
          address,
          zip,
          pref_code: prefCodeDest,
          shipping_company: shippingCompany,
          tracking: '',
          quantity: quanParse,
        },
      ],
    }
    dispatch(updateOrderDestination({ dataUpdateOrderDestination, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('配送先情報が更新されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleDistNew()
  }

  // Edit
  const [modalDistEditOpen, setModalDistEditIsOpen] = useState(false)
  const toggleDistEdit = () => {
    setModalDistEditIsOpen((prev) => !prev)
  }

  // New Destination
  const [modalNew, setModalNew] = useState(false)

  const toggleDistNew = () => {
    setModalNew((prev) => !prev)
    setName('')
    setPrefCodeDest('')
    setZip('')
    setAddress('')
    setShippingCompany('')
    setTel('')
  }

  useEffect(() => {
    setQuantity(targetData?.quantity || 0)
    setShippingCompany(targetData?.shipping_company || '')
  }, [targetData])

  const editDestinationHandler = ({ dest, index }) => {
    setTargetData(dest)
    setCurrentIndex(index)
    toggleDistEdit()
  }

  const updateDistributionQuantityHandler = () => {
    const data = {
      order_key: dataDetail.order_key,
    }
    const dataQuantityChange = {
      order_key: dataDetail.order_key,
      destination_index: currentIndex,
      quantity: Math.abs(quantity),
    }
    // console.log({
    //   dataDetail,
    //   dataQuantityChange,
    // })

    dispatch(updateDistributionQuantity({ dataQuantityChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('配送数量が変更されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleDistEdit()
    setTargetData(null)
  }

  // Delete
  const [modalDistDeleteOpen, setModalDistDeleteIsOpen] = useState(false)
  const toggleDistDelete = () => {
    setModalDistDeleteIsOpen((prev) => !prev)
  }

  const deleteDestinationHandler = ({ dest, index }) => {
    setTargetData(dest)
    setCurrentIndex(index)
    toggleDistDelete()
  }

  const deleteDistributionDestinationHandler = () => {
    const data = {
      order_key: dataDetail.order_key,
    }
    const dataDelete = {
      order_key: dataDetail.order_key,
      delete_index: currentIndex,
    }

    dispatch(deleteDistributionDestination({ dataDelete, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success(' 配送先が削除されました。')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleDistDelete()
    setTargetData(null)
  }

  // Confirm Distribution Area
  const [modalConfirmDistributionArea, setModalDistributionArea] =
    useState(false)
  const toggleConfirmDistributionArea = () => {
    setModalDistributionArea((prev) => !prev)
  }
  const confirmDistributionAreaHandler = (e) => {
    e.preventDefault()
    const data = {
      order_key: dataDetail.order_key,
    }
    console.log(data)
    dispatch(confirmDistributionDestination({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleConfirmDistributionArea()
  }

  return (
    <>
      <div className="w-full w-12/12 flex flex-col sm:flex-row gap-2 mt-8 overflow-x-auto">
        <div className="order__detail_area w-full w-12/12 flex flex-col ">
          <table className="w-[100%] text-left">
            <thead>
              <tr>
                <th
                  colSpan="9"
                  className="bg-primary bg-opacity-50 text-md font-bold border-[1px] border-black px-2 py-[4px]"
                >
                  <div className="flex justify-between">
                    {/* Left */}
                    <div className="flex gap-4 font-light text-sm md:text-base">
                      <p className="font-bold">配送先</p>
                      <p>
                        配布部数:{' '}
                        {dataDetail && dataDetail?.estimation?.quantity}
                      </p>
                      <p>発送部数: {total || 0}</p>
                      <p className="font-bold">
                        差分: {dataDetail?.estimation?.quantity - total}
                      </p>
                    </div>
                    {/* Right */}
                    {dataDetail?.destinations?.length > 0 &&
                    dataDetail?.extra?.sync?.destination_fixed === 0 ? (
                      <button
                        onClick={toggleConfirmDistributionArea}
                        className="bg-blue-700 text-white font-normal px-4 hover:bg-opacity-80"
                      >
                        確定
                      </button>
                    ) : (
                      <>
                        {dataDetail?.extra?.sync?.destination_fixed === 1 && (
                          <div className="mx-2 text-green-700 text-xl font-light flex justify-center items-center">
                            <FaCheck />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </th>
              </tr>
              <tr className="order__detail_area_table_header text-sm">
                <th>ID</th>
                <th>郵便番号</th>
                {/* <th>都道府県</th> */}
                <th>住所</th>
                <th>配送先名</th>
                <th>Tel</th>
                <th>部数</th>
                <th>配送業者</th>
                <th>追跡番号</th>
                <th>
                  編集/ <br /> 削除
                </th>
              </tr>
            </thead>
            <tbody className="text-xs">
              {destinationsList &&
                destinationsList.map((dest, index) => (
                  <tr key={index}>
                    <td>{dest.id}</td>
                    <td>{dest.zip}</td>
                    {/* <td>{dest.pref_code}</td> */}
                    <td>{dest.address}</td>
                    <td>{dest.name}</td>
                    <td>{dest.tel}</td>
                    <td>{dest.quantity}</td>
                    <td>{dest.shipping_company}</td>
                    <td>
                      {dest.tracking.split(',').map((tr, idx) => (
                        <p key={idx}>{tr}</p>
                      ))}
                    </td>
                    <td>
                      <div className="flex flex-col justify-center items-start text-md font-bold">
                        <p
                          onClick={() =>
                            editDestinationHandler({ dest, index })
                          }
                          className="flex items-center gap-[2px] cursor-pointer text-blue-700"
                        >
                          編集 <FaEdit />
                        </p>
                        <p
                          onClick={() =>
                            deleteDestinationHandler({ dest, index })
                          }
                          className="flex items-center gap-[2px] cursor-pointer text-red-700"
                        >
                          削除 <FaTrashAlt />
                        </p>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Button */}
      <div className="flex w-full justify-end gap-2 mt-4 mb-4">
        <button
          onClick={toggleDistNew}
          className="px-4 py-2 bg-blue-600 text-white"
        >
          フリーテキストで配送先を追加
        </button>
        <button
          onClick={addDestinationAreaHandler}
          className="px-4 py-2 bg-blue-600 text-white"
        >
          配送先を追加する
        </button>
      </div>
      {/* End Button */}

      {/* Modal Add Destinations */}
      <Modal
        isOpen={modalDistOpen}
        onRequestClose={toggleDistSteps}
        style={customStyles}
        contentLabel="Add Destinations"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={toggleDistSteps}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold ">
          配送先の追加
        </h2>
        <form
          onSubmit={submitAddDestinationAreaHandler}
          className="p-2 flex flex-col"
        >
          <div className="flex flex-col justify-end gap-2">
            <div className="w-full w-12/12 flex flex-col sm:flex-row gap-2 mt-8 overflow-x-auto overflow-y-auto max-h-[50vh]">
              <div className="order__detail_area w-full w-12/12 flex flex-col ">
                {order_destination_loading ? (
                  <SpinnerComp />
                ) : (
                  <table className="w-[100%] text-left">
                    <thead>
                      <tr className="order__detail_area_table_header text-sm lg:text-md">
                        <th className="w-[36px]">ID</th>
                        <th>Post code</th>
                        <th>Name</th>
                        <th>Address</th>
                        <th>Tel</th>
                        <th>Mail</th>
                        <th className="text-center">Select</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm lg:text-md">
                      {filteredDestinations &&
                        destinationsValue !== 'token_expired' &&
                        filteredDestinations?.map((dest, idx) => (
                          <tr key={idx}>
                            <td>{dest.id}</td>
                            <td>{dest.zip}</td>
                            <td>{dest.name}</td>
                            <td>{dest.address}</td>
                            <td>{dest.tel}</td>
                            <td>{dest.mail}</td>
                            <td className="text-center">
                              <input
                                value={dest}
                                checked={dest.checked}
                                onChange={() => checkHandler(dest.id)}
                                type="checkbox"
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                type="submit"
              >
                確定する
              </button>

              <button
                onClick={toggleDistSteps}
                className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                type="button"
              >
                キャンセル
              </button>
            </div>
          </div>
        </form>
      </Modal>
      {/* End Modal Add Destinations */}

      {/* Edit Destination Modal */}
      {targetData && (
        <Modal
          isOpen={modalDistEditOpen}
          onRequestClose={toggleDistEdit}
          style={customStylesEditModal}
          contentLabel="Edit Destination"
        >
          <button
            className="float-right rounded-full text-black text-xl"
            onClick={toggleDistEdit}
          >
            <FaTimes />
          </button>
          <h2 className="text-left px-2 text-md sm:text-xl font-semibold ">
            配送先の編集
          </h2>
          <div className="w-full w-12/12 flex flex-col sm:flex-row gap-2 mt-8 overflow-x-auto">
            <div className="order__detail_area_edit w-full w-12/12 flex flex-col ">
              <table className="w-[100%] text-left">
                <thead>
                  <tr className="order__detail_area_table_header text-sm lg:text-md">
                    <th>ID</th>
                    <th>郵便番号</th>
                    {/* <th>都道府県</th> */}
                    <th>住所</th>
                    <th>配送先名</th>
                    <th>Tel</th>
                    <th>部数</th>
                    <th>配送業者</th>
                    <th>追跡番号</th>
                  </tr>
                </thead>
                <tbody className="text-sm lg:text-md">
                  <tr>
                    <td>{targetData?.id}</td>
                    <td>{targetData?.zip}</td>
                    {/* <td>{targetData?.pref_code}</td> */}
                    <td>{targetData?.address}</td>
                    <td>{targetData?.name}</td>
                    <td>{targetData?.tel}</td>
                    <td>
                      <input
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        className="w-full outline-none border-[1px] border-black px-[2px]"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={shippingCompany}
                        onChange={(e) => setShippingCompany(e.target.value)}
                        className="w-full outline-none border-[1px] border-black px-[2px]"
                      />
                    </td>
                    <td>
                      {targetData?.tracking?.split(',').map((tr, idx) => (
                        <p key={idx}>{tr}</p>
                      ))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={updateDistributionQuantityHandler}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              確定する
            </button>
            <button
              onClick={toggleDistEdit}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              キャンセル
            </button>
          </div>
        </Modal>
      )}
      {/* End Edit Modal */}

      {/* New Dest */}
      <Modal
        isOpen={modalNew}
        onRequestClose={toggleDistNew}
        style={customStylesEditModal}
        contentLabel="Edit Destination"
      >
        <form onSubmit={submitFreeText}>
          <button
            className="float-right rounded-full text-black text-xl"
            onClick={toggleDistNew}
          >
            <FaTimes />
          </button>
          <h2 className="text-left px-2 text-md sm:text-xl font-semibold ">
            フリーテキストで配送先を追加
          </h2>
          <div className="w-full w-12/12 flex flex-col sm:flex-row gap-2 mt-8 overflow-x-auto">
            <div className="order__detail_area_edit w-full w-12/12 flex flex-col ">
              <table className="w-[100%] text-left">
                <thead>
                  <tr className="order__detail_area_table_header text-sm lg:text-md">
                    <th>
                      郵便番号 <span className="text-red-700">*</span>
                    </th>
                    <th>
                      都道府県 <span className="text-red-700">*</span>
                    </th>
                    <th>
                      住所<span className="text-red-700">*</span>
                    </th>
                    <th>
                      配送先名<span className="text-red-700">*</span>
                    </th>
                    <th>
                      Tel<span className="text-red-700">*</span>
                    </th>
                    <th>
                      部数 
                      {/* <span className="text-red-700">*</span> */}
                    </th>
                    <th>
                      配送業者 
                      {/* <span className="text-red-700">*</span> */}
                    </th>
                    <th>追跡番号</th>
                  </tr>
                </thead>
                <tbody className="text-sm lg:text-md">
                  <tr>
                    <td>
                      <input
                        type="text"
                        value={zip}
                        onChange={(e) => setZip(e.target.value)}
                        className="w-full outline-none  px-[2px]"
                        required
                      />
                    </td>
                    <td>
                      <select
                        className="outline-none bg-white border border-black px-2"
                        name="select-prefecture-dest"
                        id="select-prefecture-dest"
                        value={prefCodeDest}
                        onChange={(event) =>
                          setPrefCodeDest(event.target.value)
                        }
                        required
                      >
                        <option value="">-- 選択 --</option>
                        {prefecture_list.map((pl) => (
                          <option value={pl.code} key={pl.code}>
                            {pl.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="w-full outline-none  px-[2px]"
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full outline-none  px-[2px]"
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={tel}
                        onChange={(e) => setTel(e.target.value)}
                        className="w-full outline-none  px-[2px]"
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        className="w-full  outline-none px-[2px]"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={shippingCompany}
                        onChange={(e) => setShippingCompany(e.target.value)}
                        className="w-full outline-none  px-[2px]"
                      />
                    </td>
                    <td>{''}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              // onClick={updateDistributionQuantityHandler}

              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="submit"
            >
              確定する
            </button>
            <button
              onClick={toggleDistNew}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              キャンセル
            </button>
          </div>
        </form>
      </Modal>
      {/* New Dest */}

      {/* Delete Distribution Modal */}
      <Modal
        isOpen={modalDistDeleteOpen}
        onRequestClose={toggleDistDelete}
        style={customStyles}
        contentLabel="Delete Distribution"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={toggleDistDelete}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold ">
          配送先の削除
        </h2>
        <div className="w-full w-12/12 flex flex-col sm:flex-row gap-2 mt-8 overflow-x-auto">
          <p>ID:{targetData?.id} の配送先を削除してよろしいですか？</p>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={deleteDistributionDestinationHandler}
            className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
            type="button"
          >
            確定する
          </button>
          <button
            onClick={toggleDistDelete}
            className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
            type="button"
          >
            キャンセル
          </button>
        </div>
      </Modal>
      {/* End Delete Modal */}

      {/* Confirm Distribution Area Modal */}
      <Modal
        isOpen={modalConfirmDistributionArea}
        onRequestClose={toggleConfirmDistributionArea}
        style={customStyles}
        contentLabel="Confirm Distribution Area"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={toggleConfirmDistributionArea}
        >
          <FaTimes />
        </button>

        <div className="w-full w-12/12 flex flex-col justify-center items-center sm:flex-row gap-2 my-8 overflow-x-auto">
          <p className="text-lg font-semibold">
            発送先を確定してよろしいですか？
          </p>
        </div>

        <div className="flex gap-2 justify-center items-center">
          <button
            onClick={toggleConfirmDistributionArea}
            className="min-w-[120px] bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
            type="button"
          >
            閉じる
          </button>
          <button
            onClick={confirmDistributionAreaHandler}
            className="min-w-[120px] bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
            type="button"
          >
            OK
          </button>
        </div>
      </Modal>
      {/* End Confirm Distribution Area Modal */}
    </>
  )
}

const customStylesEditModal = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 1000,
  },
  content: {
    maxHeight: '80vh',
    width: '95%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

export default DistibutionArea
